<h4 *ngIf="config.title"><b>{{config.title | localize}}</b></h4>
<ano-table class="bills" [tableConfig]="config.tableConfig"
           [withSearch]="config.withSearch"
           [timeRangeConfig]="config.withTimeRange && timeRangeConfig"
></ano-table>
